import React from 'react';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

const SkeletonGrid = ({ colCount, rowCount , className}) => {
  return (
    <>
      {[...Array(rowCount)].map((_, rowIndex) => (
        <Row key={rowIndex}>
          {[...Array(colCount)].map((_, colIndex) => (
            <Col key={colIndex}>
              <Skeleton className={className}/>
            </Col>
          ))}
        </Row>
      ))}
    </>
  );
};

SkeletonGrid.propTypes = {
  colCount: PropTypes.number,
  rowCount: PropTypes.number,
  className : PropTypes.string
};

export default SkeletonGrid;